// Sidebar entries owned by the MailerCampaign module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { mailerCampaignPaths } from './paths'

export const mailerCampaignNav = {
    campaigns: {
        title: 'mailerCampaign:sidebar_title',
        path: mailerCampaignPaths.mailerCampaign,
    },
} satisfies Record<string, SidebarType>
